import React from "react";

interface CalloutSectionProps {
  quote: React.ReactNode;
  cite: React.ReactNode;
  // "pull" is the display-scale pull quote for a short, punchy line. "testimonial" drops to a
  // reading scale for a full customer quote, which runs far too tall at pull-quote size.
  variant?: "pull" | "testimonial";
}

const CalloutSection: React.FC<CalloutSectionProps> = ({ quote, cite, variant = "pull" }) => {
  return (
    <section
      className={`cs-section cs-callout${variant === "testimonial" ? " cs-callout-testimonial" : ""}`}
      data-testid="callout"
    >
      <div className="cs-callout-inner">
        <div className="cs-callout-mark">&ldquo;</div>
        <blockquote>{quote}</blockquote>
        <cite>{cite}</cite>
      </div>
    </section>
  );
};

export default CalloutSection;
